import { FC, useState, useEffect, useRef } from 'react';
import Image from '@base/lib/ThemeImage';
import { useProductContext } from 'mod/product-list/useProductContext';
import { Tags } from './Tags';
import { isSoldOut } from 'mod/product-list/utils';
import { Mask } from 'mod/product-list/ProductPicture/Mask';
import { IProduct } from 'mod/product/interface';
import { isVideoUrl } from 'base/utils/file';
import PureVideo, { IPureVideoRef } from '@base/lib/PureVideo';
import useHover from 'base/hooks/useHover';
import { useTrans } from 'base/utils/i18n';

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

export const HoverMedia: FC = () => {
    const [canLoad, setCanLoad] = useState<boolean>(false);
    const videoRef = useRef<IPureVideoRef>(null);

    const {
        product,
        imageSize,
        picture = {},
    } = useProductContext();

    const { fixed = false } = picture;
    const { url = '', altText = '' } = product.hoverPic as IProduct['pic'];
    const isVideo = isVideoUrl(url);
    const [container, setContainer] = useState<HTMLDivElement>();

    useEffect(() => {
        setTimeout(() => {
            setCanLoad(true);
        }, 3000)
    }, []);

    useEffect(() => {
        if (videoRef.current) {
            setContainer(videoRef.current.getElements().wrap.closest('.js-product') as HTMLDivElement);
        }
    }, [canLoad]);

    useHover(container, {
        onEnter: () => {
            videoRef.current?.play()
        },
        onLeave: () => {
            videoRef.current?.pause()
        }
    })

    if (!canLoad) {
        return null;
    }
    return isVideo ? (
        <PureVideo
            className={'mask g-hover-top'}
            src={url}
            ref={videoRef}
            loop={true}
            muted={true}
            absolute
        />
    ) : (
        <Image
            className={'g-hover-top'}
            src={url}
            alt={altText || product.title}
            width={imageSize}
            fixed={fixed}
            absolute
        />
    )
};

export const Main: FC = () => {
    const {
        product,
        imageSize,
        picture = {},
    } = useProductContext();
    const { t } = useTrans();

    const { showHoverPic = true, fixed = false, showSoldOut = true, mask } = picture;
    const hasHoverMedia = showHoverPic && !isPhone && product.hoverPic?.url;

    return (
        <>
            {hasHoverMedia ? (
                <div className={'relative'}>
                    <Image
                        className={'g-hover-bottom'}
                        src={product.pic.url}
                        alt={product.pic.altText || product.title}
                        width={imageSize}
                        fixed={fixed}
                    />
                    <HoverMedia/>
                </div>
            ) : (
                <Image
                    src={product.pic.url}
                    alt={product.pic.altText || product.title}
                    width={imageSize}
                    fixed={fixed}
                />
            )}

            <Tags/>

            {mask || (showSoldOut && isSoldOut(product) && <Mask text={t('web_product_sold_out')}/>)}
        </>
    )
};